import { render } from "./vipClassParts.vue?vue&type=template&id=4be3cc30&scoped=true&ts=true"
import script from "./vipClassParts.vue?vue&type=script&lang=ts"
export * from "./vipClassParts.vue?vue&type=script&lang=ts"

import "./vipClassParts.vue?vue&type=style&index=0&id=4be3cc30&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be3cc30"]])

export default __exports__